import { StandardEvents } from '@shopify/events';

class AmpedCartCount extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate, { signal: this.controller.signal });
    window.addEventListener('pageshow', this.onPageShow, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.request?.abort();
  }

  renderCount(count) {
    if (Number.isInteger(count) && count >= 0) this.textContent = `(${count})`;
  }

  onCartUpdate = (event) => {
    event.promise?.then(({ cart, detail }) => {
      this.request?.abort();
      this.renderCount(cart?.totalQuantity ?? detail?.itemCount);
    }).catch(() => {});
  };

  onPageShow = async (event) => {
    if (!event.persisted) return;
    this.request?.abort();
    this.request = new AbortController();
    try {
      const link = this.closest('a');
      if (!link) return;
      const response = await fetch(`${link.pathname}.js`, { credentials: 'same-origin', cache: 'no-store', signal: this.request.signal });
      if (response.ok) this.renderCount((await response.json()).item_count);
    } catch {}
  };
}

if (!customElements.get('amped-cart-count')) customElements.define('amped-cart-count', AmpedCartCount);
